module.exports = __webpack_public_path__ + "static/media/splash-photo-left.29d8695a.jpg";